import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';
export const API_URL  = `${BASE_URL}/api`;

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  // Don't attach token to login requests
  if (config.url?.includes('/login') || config.url?.includes('/college-login')) {
    delete config.headers.Authorization;
    return config;
  }
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // If token is invalid/expired, clear it
    if (err.response?.status === 401 && err.config?.url?.includes('/me')) {
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
    }
    return Promise.reject(err);
  }
);

export default api;
